import React from "react";
import ParticleBackground from "../components/ParticleBackground";
import {
  FaLaptop,
  FaCalendarAlt,
  FaClipboardCheck,
  FaExclamationTriangle,
  FaBookReader,
  FaClock,
  FaCheckCircle,
  FaHeadset,
  FaExternalLinkAlt,
  FaDesktop,
  FaGraduationCap,
  FaFileAlt,
  FaArrowRight,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const OnlineExam = () => {
  const instructions = [
    {
      num: "01",
      icon: <FaDesktop className="text-success" />,
      title: "Examination & LMS Portal",
      desc: "The examination will be conducted online through the official Hunarmand Punjab LMS portal. Students who could not attempt their first exam due to an issue may now attempt it through the LMS portal. Check your LMS login credentials before exam day. For login or technical issues, contact the official support team through the complaint portal.",
      badge: "LMS Portal",
    },
    {
      num: "02",
      icon: <FaCalendarAlt className="text-primary" />,
      title: "Examination Schedule",
      desc: "Attempt the exam only on the officially announced date and time. Log in before the scheduled start time and follow the announced exam duration.",
      badge: "Schedule",
    },
    {
      num: "03",
      icon: <FaLaptop className="text-danger" />,
      title: "Laptop & Internet Requirements",
      desc: "A laptop is mandatory; mobile phones are not permitted. Check your laptop and ensure your internet/Wi-Fi connection is stable before starting. Students are responsible for internet interruptions or submission problems caused by an unstable connection.",
      badge: "Mandatory",
    },
    {
      num: "04",
      icon: <FaClipboardCheck className="text-warning" />,
      title: "Answers & Final Submission",
      desc: "Review your answers and ensure they are saved before submitting. Submit your paper before the allotted time ends. Once submitted, an attempt may not be recoverable or reversible.",
      badge: "Submission",
    },
    {
      num: "05",
      icon: <FaClock className="text-danger" />,
      title: "Strict Time-Limit Policy",
      desc: "When the allotted examination time ends, your final exam will be removed from your portal. Submit your paper before the given time expires.",
      badge: "Countdown",
    },
    {
      num: "06",
      icon: <FaBookReader className="text-info" />,
      title: "Course Selection Policy",
      desc: "Students enrolled in two courses may attempt the final exam for only one course. Select your course carefully before starting. Attempting both courses may result in cancellation of the first attempt as well.",
      badge: "Policy",
    },
  ];

  const checklistItems = [
    { label: "Laptop works properly (Mobile phones are not permitted)" },
    { label: "Internet / Wi-Fi connection is fast and stable" },
    { label: "LMS login is active and verified before exam day" },
    { label: "Official examination schedule and date sheet have been checked" },
    { label: "You understand all examination rules & course selection policy" },
  ];

  return (
    <div className="online-exam-page" style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      {/* Hero / Header Section */}
      <div
        className="breadcrums position-relative text-white py-5"
        style={{
          background: "linear-gradient(135deg, #0d3b24 0%, #065f46 50%, #047857 100%)",
          overflow: "hidden",
        }}
      >
        <ParticleBackground />
        <div className="container position-relative" style={{ zIndex: 2 }}>
          <div className="text-center py-4">
            <span
              className="badge px-3 py-2 mb-3 text-uppercase font-12 font-md-14 text-wrap"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.15)",
                backdropFilter: "blur(6px)",
                letterSpacing: "1px",
                borderRadius: "30px",
                border: "1px solid rgba(255, 255, 255, 0.3)",
                maxWidth: "100%",
                display: "inline-block",
                wordBreak: "break-word",
                whiteSpace: "normal",
              }}
            >
              <FaGraduationCap className="me-2" />
              Hunarmand Punjab Official Examination Notice
            </span>
            <h1 className="fw-bold fs-2 fs-md-1 mb-2 text-white">
              Online Final Examinations
            </h1>
            <p className="lead mb-0 text-white-50 font-16 font-md-20">
              Online Final Examinations — Batch 1 &amp; Batch 2 Official Rules &amp; Instructions
            </p>
          </div>
        </div>
      </div>

      <div className="container py-4 py-md-5">
        {/* TWO DEDICATED SEPARATE PAGE BUTTONS (ABOVE IMPORTANT ELIGIBILITY NOTICE) */}
        <div className="row mb-4 justify-content-center">
          <div className="col-lg-11">
            <div
              className="p-3 p-md-4 rounded-4 shadow-sm"
              style={{
                background: "#ffffff",
                border: "1px solid #e2e8f0",
              }}
            >
              <div className="row align-items-center g-3">
                <div className="col-12 col-lg-5">
                  <h5 className="fw-bold text-dark mb-1">
                    Examination Schedule &amp; Guide
                  </h5>
                  <p className="text-muted mb-0 font-14">
                    Open the complete Date Sheet or the Step-by-Step Paper Attempt Guide on separate pages:
                  </p>
                </div>
                <div className="col-12 col-lg-7">
                  <div className="d-flex flex-column flex-sm-row gap-2 justify-content-lg-end">
                    <Link
                      to="/exam-datesheet"
                      className="btn btn-success fw-bold px-4 py-3 d-inline-flex align-items-center justify-content-center shadow-sm text-center"
                      style={{ borderRadius: "10px", fontSize: "15px" }}
                    >
                      <FaCalendarAlt className="me-2" />
                      Date Sheet <FaArrowRight className="ms-2 font-12" />
                    </Link>
                    <Link
                      to="/how-to-attempt-exam"
                      className="btn btn-primary fw-bold px-4 py-3 d-inline-flex align-items-center justify-content-center shadow-sm text-center"
                      style={{
                        borderRadius: "10px",
                        backgroundColor: "#1e40af",
                        borderColor: "#1e40af",
                        fontSize: "15px",
                      }}
                    >
                      <FaFileAlt className="me-2" />
                      How to Attempt &amp; Submit Paper <FaArrowRight className="ms-2 font-12" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CRITICAL PROJECT SUBMISSION REQUIREMENT NOTICE */}
        <div className="row mb-4 justify-content-center">
          <div className="col-lg-11">
            <div
              className="card border-0 shadow-lg"
              style={{
                borderRadius: "16px",
                borderLeft: "8px solid #dc2626",
                background: "#fff5f5",
                boxShadow: "0 10px 25px -5px rgba(220, 38, 38, 0.15), 0 8px 10px -6px rgba(220, 38, 38, 0.1)",
              }}
            >
              <div className="card-body p-4 p-md-4">
                <div className="d-flex align-items-start gap-3">
                  <div
                    className="p-3 rounded-circle text-white d-flex align-items-center justify-content-center flex-shrink-0 shadow-sm"
                    style={{ backgroundColor: "#dc2626", width: "56px", height: "56px", fontSize: "24px" }}
                  >
                    <FaExclamationTriangle />
                  </div>
                  <div>
                    <span className="badge bg-danger mb-2 px-3 py-1 text-uppercase fw-bold font-12" style={{ letterSpacing: "1px" }}>
                      ⚠️ MOST IMPORTANT INSTRUCTION / انتہائی ضروری ہدایت
                    </span>
                    <h3 className="h4 fw-bolder text-danger mb-2" style={{ letterSpacing: "-0.5px" }}>
                      Final Project Submission Requirement for Final Exam
                    </h3>
                    <p
                      className="fw-bold mb-2 text-dark font-16 font-md-18"
                      style={{ lineHeight: "1.7", color: "#111827" }}
                    >
                      Students must appear in the final exam for the same course for
                      which they have submitted their final project. If a student has
                      submitted final projects for two courses, they may choose to
                      appear in the final exam for either one of those courses.
                    </p>
                    <div
                      className="mt-2 p-3 rounded-3 bg-white border border-danger-subtle text-danger-emphasis fw-bold font-14 font-md-15"
                      style={{ lineHeight: "1.8" }}
                    >
                      <span>اردو میں اہم ہدایت: </span>
                      طلباء کے لیے اسی کورس کے فائنل امتحان میں شرکت کرنا لازمی ہے جس کورس کا
                      انہوں نے فائنل پروجیکٹ جمع کروایا ہے۔ اگر کسی طالب علم نے دو مختلف
                      کورسز کے فائنل پروجیکٹس جمع کروائے ہیں، تو وہ ان دونوں میں سے کسی
                      ایک کورس کے فائنل امتحان میں شرکت کا انتخاب کر سکتا ہے۔
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CRITICAL ELIGIBILITY NOTICE ALERT */}
        <div className="row mb-5 justify-content-center">
          <div className="col-lg-11">
            <div
              className="card border-0 shadow-sm"
              style={{
                borderRadius: "16px",
                borderLeft: "6px solid #dc2626",
                background: "#fff",
              }}
            >
              <div className="card-body p-4 p-md-5">
                <div className="d-flex align-items-start gap-3">
                  <div
                    className="p-3 rounded-circle text-danger d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{ backgroundColor: "#fee2e2", width: "56px", height: "56px", fontSize: "24px" }}
                  >
                    <FaExclamationTriangle />
                  </div>
                  <div>
                    <span className="badge bg-danger mb-2 px-3 py-1 text-uppercase">
                      Important Eligibility Notice
                    </span>
                    <h3 className="h4 fw-bold text-dark mb-2">
                      Physical Exam Candidates Are Not Eligible
                    </h3>
                    <p className="text-secondary mb-0 font-16" style={{ lineHeight: "1.7" }}>
                      Students who have already taken their physical examination at{" "}
                      <strong className="text-danger">Punjab University, Lahore</strong> are{" "}
                      <strong className="text-danger">NOT ELIGIBLE</strong> to appear in the Hunarmand Punjab Online Final Examination.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* WHERE TO FIND YOUR EXAM PAPER */}
        <div className="row mb-5 justify-content-center">
          <div className="col-lg-11">
            <div
              className="card border-0 text-white shadow-sm"
              style={{
                borderRadius: "16px",
                background: "linear-gradient(135deg, #1e3a8a 0%, #1e40af 60%, #3b82f6 100%)",
              }}
            >
              <div className="card-body p-4 p-md-5">
                <div className="row align-items-center">
                  <div className="col-lg-8">
                    <span
                      className="badge px-3 py-1 mb-3 text-uppercase font-12"
                      style={{
                        backgroundColor: "rgba(255, 255, 255, 0.2)",
                        border: "1px solid rgba(255, 255, 255, 0.3)",
                      }}
                    >
                      <FaDesktop className="me-2" />
                      Where to Find Your Exam Paper
                    </span>
                    <h3 className="h3 fw-bold mb-3 text-white">
                      Where to Find Your Exam Paper
                    </h3>
                    <p className="mb-3 text-white-50 font-16" style={{ lineHeight: "1.7" }}>
                      Your final exam paper will appear at the <strong className="text-white">top of the relevant course</strong> inside your representative LMS portal. Open the course for which you want to take the final exam and look at the top of the course page.
                    </p>
                    <div
                      className="p-3 mb-4 rounded-3 d-flex align-items-center gap-2"
                      style={{
                        backgroundColor: "rgba(220, 38, 38, 0.25)",
                        border: "1px solid rgba(248, 113, 113, 0.6)",
                        backdropFilter: "blur(6px)",
                      }}
                    >
                      <FaExclamationTriangle className="text-warning flex-shrink-0 font-20" />
                      <span className="font-15 text-white">
                        <strong className="text-warning text-uppercase">STRICT WARNING:</strong> The use of <strong className="text-white text-decoration-underline">Artificial Intelligence (AI tools like ChatGPT, etc.) is STRICTLY PROHIBITED</strong>. Anyone found using AI will face immediate paper cancellation.
                      </span>
                    </div>
                    <div className="d-flex flex-wrap gap-3">
                      <a
                        href="https://lms.hunarmandpunjab.org.pk/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-light fw-bold px-4 py-2 d-inline-flex align-items-center"
                        style={{ borderRadius: "8px", color: "#1e3a8a" }}
                      >
                        Open LMS Portal <FaExternalLinkAlt className="ms-2 font-12" />
                      </a>
                      <a
                        href="https://complaint.hunarmandpunjab.org.pk/login"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-light fw-semibold px-4 py-2 d-inline-flex align-items-center"
                        style={{ borderRadius: "8px" }}
                      >
                        <FaHeadset className="me-2" /> Complaint Portal
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-4 text-center mt-4 mt-lg-0">
                    <div
                      className="p-4 rounded-4"
                      style={{
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                        backdropFilter: "blur(10px)",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                    >
                      <FaDesktop style={{ fontSize: "52px", opacity: 0.9 }} className="mb-3" />
                      <h5 className="fw-bold mb-1">Simple Steps</h5>
                      <div className="text-white-50 font-14">
                        1. Open LMS Portal <br />
                        2. Select Enrolled Course <br />
                        3. See Exam at Top <br />
                        4. Start on Schedule
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION HEADER: EXAMINATION RULES & INSTRUCTIONS */}
        <div className="text-center mb-5">
          <span className="text-success fw-bold text-uppercase font-14" style={{ letterSpacing: "1.5px" }}>
            Official Examination Rules &amp; Instructions
          </span>
          <h2 className="fw-bold text-dark mt-1">Examination Rules &amp; Instructions</h2>
          <p className="text-muted">Carefully review each rule to ensure a successful examination attempt</p>
        </div>

        {/* ORIGINAL 6 RULES GRID */}
        <div className="row g-4 mb-5 justify-content-center">
          {instructions.map((item, idx) => (
            <div className="col-md-6 col-lg-4 d-flex" key={idx}>
              <div
                className="card border-0 shadow-sm w-100 position-relative"
                style={{
                  borderRadius: "16px",
                  background: "#ffffff",
                }}
              >
                <div className="card-body p-4 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span
                      className="fw-bold font-24"
                      style={{ color: "#cbd5e1", letterSpacing: "1px" }}
                    >
                      {item.num}
                    </span>
                    <span
                      className="badge px-3 py-1 font-12"
                      style={{
                        backgroundColor: "#f1f5f9",
                        color: "#475569",
                        fontWeight: "600",
                        borderRadius: "20px",
                      }}
                    >
                      {item.badge}
                    </span>
                  </div>
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div
                      className="p-3 rounded-3 d-flex align-items-center justify-content-center"
                      style={{ backgroundColor: "#f8fafc", fontSize: "20px" }}
                    >
                      {item.icon}
                    </div>
                    <h5 className="fw-bold text-dark mb-0">{item.title}</h5>
                  </div>
                  <p className="text-secondary font-14 mb-0 flex-grow-1" style={{ lineHeight: "1.7" }}>
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* TIME-LIMIT WARNING CALLOUT BOX */}
        <div className="row mb-5 justify-content-center">
          <div className="col-lg-11">
            <div
              className="p-4 p-md-5 rounded-4"
              style={{
                backgroundColor: "#fff1f2",
                border: "2px dashed #f43f5e",
              }}
            >
              <div className="d-flex align-items-center gap-3 mb-3">
                <FaClock className="text-danger font-24" />
                <h4 className="fw-bold text-danger mb-0">TIME-LIMIT WARNING</h4>
              </div>
              <p className="text-dark font-16 mb-0" style={{ lineHeight: "1.7" }}>
                When the allotted examination time ends, your final exam will be removed from your portal. Submit your paper before the given time expires.
              </p>
            </div>
          </div>
        </div>

        {/* FINAL CHECKLIST */}
        <div className="row mb-5 justify-content-center">
          <div className="col-lg-11">
            <div
              className="card border-0 shadow-sm"
              style={{
                borderRadius: "16px",
                background: "#ffffff",
              }}
            >
              <div className="card-body p-4 p-md-5">
                <div className="d-flex align-items-center gap-3 mb-4">
                  <div
                    className="p-3 rounded-circle text-success d-flex align-items-center justify-content-center"
                    style={{ backgroundColor: "#dcfce7", width: "52px", height: "52px", fontSize: "22px" }}
                  >
                    <FaClipboardCheck />
                  </div>
                  <div>
                    <h3 className="h4 fw-bold text-dark mb-1">Final Checklist</h3>
                    <p className="text-muted mb-0 font-14">
                      Before starting, confirm that your laptop works, your internet is stable, your LMS login is active, you have checked the official schedule, and you understand the examination rules.
                    </p>
                  </div>
                </div>

                <div className="row g-3">
                  {checklistItems.map((chk, i) => (
                    <div className="col-md-6" key={i}>
                      <div
                        className="p-3 rounded-3 d-flex align-items-center gap-3"
                        style={{
                          backgroundColor: "#f8fafc",
                          border: "1px solid #e2e8f0",
                        }}
                      >
                        <FaCheckCircle className="text-success flex-shrink-0 font-18" />
                        <span className="font-14 fw-medium text-dark">{chk.label}</span>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-5 text-center pt-3 border-top">
                  <h5 className="fw-bold text-dark mb-3">Ready for the Examination?</h5>
                  <div className="d-flex flex-wrap justify-content-center gap-3">
                    <a
                      href="https://lms.hunarmandpunjab.org.pk/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-success fw-bold px-5 py-3 shadow-sm"
                      style={{ borderRadius: "10px", fontSize: "16px" }}
                    >
                      Login to LMS Portal
                    </a>
                    <a
                      href="https://complaint.hunarmandpunjab.org.pk/login"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-secondary fw-semibold px-4 py-3"
                      style={{ borderRadius: "10px", fontSize: "16px" }}
                    >
                      Complaint Portal
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default OnlineExam;
